import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { fetchStaticJson } from '../../../config/fetchStaticJson';
import pathRoutes from '../../../enums/pathRoutes';
import AdminTabs from './adminTabs/AdminTabs';
import DesignTab from './designTab/DesignTab';
import SettingsTab from './settingsTab/SettingsTab';
import AdminSaveBar from './adminSaveBar/AdminSaveBar';
import SaveInVcBar from './saveInVcBar/SaveInVcBar';
import AdminActionsDrawer from './adminActionsDrawer/AdminActionsDrawer';
import confirmClasses from '../saveJsonToBucketButton/SaveJsonToBucketButton.module.css';
import classes from './AdminPanel.module.css';

function descriptionsUrl() {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  return `${base}/config/descriptions.json`;
}

const AdminPanel = ({
  domainName,
  botName,
  draft,
  setDraft,
  discoveryButtons,
  onDiscoveryButtonsChange,
  originalImageUrls,
  onExportConfig,
  onExportBotsInVc,
  canExportBotsInVc,
  getBotsInVcContent,
  exportError,
  modalContainer,
  onSubjectSelect,
}) => {
  const navigate = useNavigate();
  const { texts, direction } = useSelector(state => state.translate);
  const [activeTab, setActiveTab] = useState('design');
  const [descriptions, setDescriptions] = useState({});
  const [showLeaveConfirm, setShowLeaveConfirm] = useState(false);

  useEffect(() => {
    fetchStaticJson(descriptionsUrl())
      .then(data => {
        if (data && typeof data === 'object') setDescriptions(data);
      })
      .catch(() => {
        setDescriptions({});
      });
  }, []);

  return (
    <div className={classes.Panel}>
      <div className={classes.Body}>
        <button
          type="button"
          className={classes.BackLink}
          onClick={() => setShowLeaveConfirm(true)}
        >
          {texts.backToBotList}
        </button>
        <AdminTabs activeTab={activeTab} onSelect={setActiveTab} />
        {activeTab === 'design' ?
          <DesignTab
            domainName={domainName}
            botName={botName}
            draft={draft}
            setDraft={setDraft}
            discoveryButtons={discoveryButtons}
            onDiscoveryButtonsChange={onDiscoveryButtonsChange}
            originalImageUrls={originalImageUrls}
            descriptions={descriptions}
            modalContainer={modalContainer}
            onSubjectSelect={onSubjectSelect}
          />
          : null}
        {activeTab === 'settings' ?
          <SettingsTab
            draft={draft}
            setDraft={setDraft}
            descriptions={descriptions}
          />
          : null}
      </div>
      <AdminActionsDrawer>
        <AdminSaveBar
          domainName={domainName}
          botName={botName}
          draft={draft}
          onExportConfig={onExportConfig}
          exportError={exportError}
        />
        <SaveInVcBar
          onExportBotsInVc={onExportBotsInVc}
          canExportBotsInVc={canExportBotsInVc}
          getBotsInVcContent={getBotsInVcContent}
        />
      </AdminActionsDrawer>
      {showLeaveConfirm ?
        <div
          className={confirmClasses.Backdrop}
          onClick={() => setShowLeaveConfirm(false)}
          role="presentation"
        >
          <div
            className={confirmClasses.Dialog}
            role="dialog"
            aria-modal="true"
            aria-labelledby="admin-leave-confirm-title"
            dir={direction || 'rtl'}
            onClick={(e) => e.stopPropagation()}
          >
            <p id="admin-leave-confirm-title" className={confirmClasses.Title}>
              {texts.leaveAdminTitle}
            </p>
            <p className={confirmClasses.Message}>
              {texts.leaveAdminConfirm}
            </p>
            <div className={confirmClasses.Actions}>
              <button
                type="button"
                className={confirmClasses.Btn}
                onClick={() => setShowLeaveConfirm(false)}
              >
                {texts.saveJsonCancel}
              </button>
              <button
                type="button"
                className={confirmClasses.BtnPrimary}
                onClick={() => navigate(`/${pathRoutes.ADMIN}`)}
              >
                {texts.leaveAdminConfirmButton}
              </button>
            </div>
          </div>
        </div>
        : null}
    </div>
  );
};

export default AdminPanel;
